import { fontSize } from "config/styles/fonts";
import { IAccentColors } from "config/types";

const styles = {
  modal: {
    width: {
      xs: "80%",
      md: "600px",
    },
    height: {
      xs: "240px",
      md: "200px",
    },
  },
  modalContent: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    p: "20px 0",
  },
  modalTitle: {
    fontWeight: 700,
    fontSize: {
      xs: fontSize.l,
      md: fontSize.xl,
    },
    textAlign: "center",
  },
  modalDescription: {
    m: "10px 0 30px 0",
    fontWeight: 300,
    textAlign: "center",
  },
  modalButtonsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: {
      xs: "column-reverse",
      md: "row",
    },
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
  },
  actionButton: (accentColor: IAccentColors) => ({
    width: "100%",
    maxWidth: {
      xs: "150px",
      md: "180px",
    },
    height: "40px",
    fontSize: "16px",
    lineHeight: "16px",
    fontWeight: 500,
    textTransform: "capitalize",
    borderRadius: "30px",
    backgroundColor: accentColor.main || "accents.main",
    borderColor: accentColor.main || "accents.main",
    color: "text.primary",
    "&:hover": {
      backgroundColor: accentColor.hover || "accents.hover",
      borderColor: accentColor.hover || "accents.hover",
    },
  }),
  modalButtonCancel: {
    width: {
      xs: "150px",
      md: "180px",
    },
    height: "40px",
    fontSize: "16px",
    lineHeight: "16px",
    fontWeight: 500,
    borderRadius: "30px",
  },
  modalIconClose: {
    position: "absolute",
    top: 8,
    right: 8,
  },
};

export default styles;
